exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-list{cursor:pointer}.card-list .headline{margin-bottom:5px}.card-list .headline__text{text-overflow:ellipsis;overflow:hidden}.card-list .card__title--primary{padding-top:10px}.card-list .card__actions{padding:0;padding-bottom:5px}.description-text{margin-top:-20px}@media only screen and (max-width:400px){.headline__text{padding-left:20px;font-size:18px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4fbf1deb","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CardList.vue
// module id = 407
// module chunks = 0